import React from 'react';
import { ThumbsUp } from 'lucide-react';
interface CommentCardProps {
  name: string;
  comment: string;
  likes: number;
  timeAgo: string;
  isReply?: boolean;
  avatarUrl?: string;
}
export function CommentCard({
  name,
  comment,
  likes,
  timeAgo,
  isReply = false,
  avatarUrl
}: CommentCardProps) {
  return <div className={`flex gap-3 ${isReply ? 'ml-12 mt-3' : 'mt-4'}`} data-id="element-1">
      <div className="flex-shrink-0" data-id="element-2">
        {avatarUrl ? <img src={avatarUrl} alt={name} className="w-10 h-10 rounded-full object-cover border border-slate-300" data-id="element-3" /> : <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center text-slate-500 font-bold text-sm border border-slate-300" data-id="element-4">
            {name.charAt(0)}
          </div>}
      </div>
      <div className="flex-1" data-id="element-5">
        <div className="bg-slate-100 rounded-2xl px-4 py-3" data-id="element-6">
          <span className="font-bold text-slate-900 text-sm block mb-1" data-id="element-7">
            {name}
          </span>
          <p className="text-slate-800 text-sm leading-snug" data-id="element-8">{comment}</p>
        </div>
        <div className="flex items-center gap-4 mt-1 ml-2" data-id="element-9">
          <div className="flex items-center gap-1 text-xs text-slate-500 font-medium cursor-pointer hover:underline" data-id="element-10">
            Like
          </div>
          <div className="flex items-center gap-1 text-xs text-slate-500 font-medium cursor-pointer hover:underline" data-id="element-11">
            Reply
          </div>
          <div className="text-xs text-slate-400" data-id="element-12">{timeAgo}</div>
          {likes > 0 && <div className="flex items-center gap-1 bg-white shadow-sm border border-slate-200 rounded-full px-1.5 py-0.5 ml-auto" data-id="element-13">
              <div className="bg-blue-500 rounded-full p-0.5" data-id="element-14">
                <ThumbsUp size={8} className="text-white fill-current" data-id="element-15" />
              </div>
              <span className="text-xs text-slate-600" data-id="element-16">{likes}</span>
            </div>}
        </div>
      </div>
    </div>;
}